var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.246 6.629a.814.814 0 00.598.246h4.781v7.031a.814.814 0 01-.246.598.813.813 0 01-.598.246H3.22a.814.814 0 01-.598-.246.813.813 0 01-.246-.598V2.094c0-.235.082-.434.246-.598a.814.814 0 01.598-.246H8v4.781c0 .235.082.434.246.598zm2.04-4.781l2.742 2.742c.292.293.483.68.57 1.16H9.126V1.276c.48.088.867.279 1.16.572z"}));
}

File.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = File;

File.default = File;
